<style scoped lang="less">
.layout-menu-group-wrapper{
   display: inline-block;
   width: 100%;
   height: 100%;
   display: flex;
   border: #2081EA solid 1px;
   align-items: center;
   .group-item{
       text-align: center;
       flex: 1;
       height: 100%;
       display: flex;
       border-right: #2081EA solid 1px;
       justify-content: center;
       align-items: center;
   }
   .group-item:nth-last-child(1){
       border-right: 0;
   }
}
</style>
<template>
    <div class="layout-menu-group-wrapper">
        <div class="group-item" v-for="(it,index) in menus" :key="index"  @click="eventClick(it,index)" :style="fontStyle(index)">
            <div class="inner">
                <div class="item-title">
                {{it.name}}
                </div>
                <div class="item-content">{{it.content}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LayoutMenuGroup',
    props: {
        blank: {
            type: Boolean,
            default: true
        },
        menus: {
            type: Array,
            default: ()=>{
                //{ name: '',content: '', link: '' }
                return []
            }
        },
        backColor: {
            type: String,
            default: ''
        },
        borderColor: {
            type: String,
            default: ''
        },
        currentBackColor: {
            type: String,
            default: ''
        },
        fontObj: {
            type: Object,
            default: ()=>{
                return {
                    fontSize: 16,
                    fontStyle: "normal",
                    color: "#E6F2FF",
                    fontFamily: "PingFang",
                    fontWeight: "normal"
                }
            }
        }
    },
    data(){
        return {
            current: 0
        }
    },
    methods: {
        eventClick(it,index){
            this.current = index;
            if( this.link ){
                this.blank  
                    ? window.location.href = it.link 
                    : this.$emit('update-iframe-link',it.link);
            }else{
                this.$emit('layout-menu-click',{
                    value: index
                });
            }
        },
        fontStyle(index){
            const {fontSize,fontStyle,fontFamily,fontWeight,color} = this.fontObj;
            const backColor = this.current === index ? this.currentBackColor : this.backColor;
            return `font-size:${fontSize}px;font-style:${fontStyle};font-family:${fontFamily};font-weight:${fontWeight};color:${color};background-color:${backColor};border-right-color:${this.borderColor}`;
        }
    }
}
</script>